import { useTranslation } from "react-i18next";

export function RouteFallback() {
	const { t } = useTranslation();
	return (
		<div className="flex h-full items-center justify-center text-[13px] text-zinc-500">
			{t("common.loading")}
		</div>
	);
}
